var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, getRawValue } from '../../utils/get';
import { getRawImageObject } from '../../adapters/get-raw-image-object';
export var getStructuredData = function (IDs, data, item) {
    var _a;
    if (!IDs) {
        return {};
    }
    var posts = getRawValue(item, 'memberPosts') || [];
    var postsJson = posts.map(function (post) {
        var datePublished = get(post, 'firstPublishedDate');
        var headline = get(post, 'title');
        var url = get(post, 'url.base') + get(post, 'url.path');
        return __assign(__assign(__assign({ '@type': 'Article' }, (headline ? { headline: headline } : {})), (url ? { url: url } : {})), (datePublished ? { datePublished: datePublished } : {}));
    });
    var image = data[IDs.MAIN_IMAGE];
    var description = data[IDs.TITLE];
    var imagesData = posts.map(function (post) {
        return {
            url: get(post, 'coverMedia.image.url'),
            width: get(post, 'coverMedia.image.width'),
            height: get(post, 'coverMedia.image.height'),
            alt: get(post, 'coverMedia.image.altText'),
        };
    });
    var _b = getRawImageObject('images', imagesData, false).images, images = _b === void 0 ? '' : _b;
    return _a = {},
        _a[IDs.SD_JSON_ARTICLES] = postsJson,
        _a[IDs.SD_JSON_IMAGES] = images,
        _a[IDs.SD_JSON_PERSON] = __assign(__assign({ '@type': 'Person', id: data[IDs.PAGE_URL], name: data[IDs.NICKNAME] }, (image ? { image: image } : {})), (description ? { description: description } : {})),
        _a;
};
